export const ImagesActionTypes = {
  API_RESPONSE_SUCCESS: '@@images/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@images/API_RESPONSE_ERROR',

  GET_IMAGES: '@@images/GET_IMAGES',

  RESET: '@@images/RESET'
}
